import { Sparkles, MapPin, Clock, Users } from "lucide-react";

export const ComingSoonEvent = () => {
  return (
    <section
      id="evento"
      data-testid="coming-soon-section"
      className="relative py-20 sm:py-28 bg-gradient-to-br from-[#1f2d22] via-[#0f1a14] to-[#1a2620] text-white overflow-hidden"
    >
      {/* Decorative blobs */}
      <div className="pointer-events-none absolute -top-40 -left-32 w-[500px] h-[500px] rounded-full bg-[#E8C9A0]/[0.06] blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 -right-32 w-[600px] h-[600px] rounded-full bg-[#C15C3D]/[0.08] blur-3xl" />

      <div className="relative max-w-6xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          {/* Image */}
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="relative group">
              <div className="rounded-3xl overflow-hidden border-2 border-white/15 aspect-[4/3] bg-black shadow-[0_25px_60px_rgba(0,0,0,0.5)]">
                <img
                  src="/condotti-asciano.jpg"
                  alt="I Condotti, Asciano"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  onError={(e) => {
                    e.currentTarget.src = "/hero-asciano.jpg";
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20" />
              </div>

              {/* Location pin */}
              <div className="absolute top-4 left-4 inline-flex items-center gap-2 bg-black/60 backdrop-blur-md border border-white/20 px-4 py-2 rounded-full">
                <MapPin className="w-4 h-4 text-[#E8C9A0]" />
                <span className="text-sm font-semibold">I Condotti · Asciano</span>
              </div>

              {/* Coming Soon badge floating */}
              <div className="absolute -bottom-5 -right-5 sm:-bottom-6 sm:-right-6 bg-[#C19A3D] text-[#1f2d22] rounded-2xl px-5 py-3 shadow-2xl rotate-[-3deg]">
                <div className="flex items-center gap-2">
                  <Sparkles className="w-5 h-5" />
                  <div className="leading-tight">
                    <div className="text-[9px] font-bold uppercase tracking-[0.2em] opacity-80">
                      In arrivo
                    </div>
                    <div className="font-display text-base font-black">
                      Coming Soon
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Copy */}
          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 backdrop-blur px-4 py-1.5 mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-[#C19A3D] animate-pulse" />
              <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.22em] text-[#E8C9A0]">
                Evento Pubblico · In organizzazione
              </span>
            </div>

            <h2
              data-testid="coming-soon-title"
              className="font-display text-4xl sm:text-5xl lg:text-6xl font-black leading-[1.02] tracking-tight"
            >
              Serata sui
              <br />
              <span className="text-[#E8C9A0] italic font-light">
                Condotti.
              </span>
            </h2>

            <div className="mt-7 space-y-5 text-base sm:text-lg text-white/85 leading-relaxed max-w-xl">
              <p>
                L'associazione sta organizzando una{" "}
                <span className="text-white font-semibold">serata pubblica</span>{" "}
                ai Condotti, dedicata alla comunità, al territorio e alla
                rinascita di Asciano.
              </p>
              <p className="text-white/70">
                Presto comunicheremo{" "}
                <span className="text-[#E8C9A0] font-semibold">
                  data, programma e modalità
                </span>{" "}
                di partecipazione.
              </p>
            </div>

            {/* Info pills */}
            <div className="mt-8 flex flex-wrap gap-3">
              <div className="inline-flex items-center gap-2 bg-white/5 border border-white/15 rounded-full px-4 py-2 text-sm">
                <Clock className="w-4 h-4 text-[#E8C9A0]" />
                <span className="text-white/85">Data in definizione</span>
              </div>
              <div className="inline-flex items-center gap-2 bg-white/5 border border-white/15 rounded-full px-4 py-2 text-sm">
                <Users className="w-4 h-4 text-[#E8C9A0]" />
                <span className="text-white/85">Aperto a tutti</span>
              </div>
              <div className="inline-flex items-center gap-2 bg-white/5 border border-white/15 rounded-full px-4 py-2 text-sm">
                <MapPin className="w-4 h-4 text-[#E8C9A0]" />
                <span className="text-white/85">I Condotti</span>
              </div>
            </div>

            <p className="mt-8 text-sm text-white/55 italic max-w-md">
              Per essere avvisato non appena la data sarà ufficiale, seguici sui
              canali ufficiali qui sotto.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
